module.exports = __webpack_public_path__ + "img/writing_white.526cc76.png";